import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { Package, Box, Truck, Calendar } from 'lucide-react';

export default function StockItemsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    const { data, error } = await supabase
      .from('stock_items')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) console.error('Erreur:', error);
    else setData(data);
    setLoading(false);
  }

  const getStockLevel = (quantity) => {
    if (quantity <= 0) return { color: 'text-red-400', bg: 'bg-red-500/20', label: 'Rupture' };
    if (quantity < 10) return { color: 'text-yellow-400', bg: 'bg-yellow-500/20', label: 'Faible' };
    return { color: 'text-green-400', bg: 'bg-green-500/20', label: 'Normal' };
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-cyan-400 flex items-center gap-2">
        <Package size={24} />
        Stock ({data.length})
      </h2>
      
      {loading ? (
        <p className="text-gray-400">Chargement...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {data.map(item => {
            const stockLevel = getStockLevel(item.quantity);
            return (
              <div key={item.id} className="bg-gray-900 rounded-xl border border-gray-800 p-5 hover:border-cyan-500/50 transition">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <Box size={20} className="text-cyan-400" />
                    <h3 className="text-white font-medium">{item.name}</h3>
                  </div>
                  <span className={`px-2 py-1 rounded-full text-xs ${stockLevel.bg} ${stockLevel.color}`}>
                    {stockLevel.label}
                  </span>
                </div>
                
                <div className="space-y-2 text-sm">
                  <p className="text-gray-300 flex items-center gap-2">
                    <span className="text-gray-500">Quantité:</span>
                    <span className="text-white font-bold">{item.quantity}</span>
                    <span className="text-gray-500">{item.unit}</span>
                  </p>
                  {item.supplier && (
                    <p className="text-gray-400 flex items-center gap-2">
                      <Truck size={14} className="text-gray-500" />
                      Fournisseur: {item.supplier}
                    </p>
                  )}
                  <p className="text-gray-500 text-xs flex items-center gap-1 mt-2">
                    <Calendar size={12} />
                    Ajouté le: {new Date(item.created_at).toLocaleDateString()}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}